import { createFileRoute } from "@tanstack/react-router"

import { HelpRouteComponent } from "@/routes/help"
import { DEFAULT_HELP_EMAIL, DEFAULT_HELP_PHONE } from "@/utilities/globals"
import { useTheme } from "@/utilities/hooks/useTheme"

export const Route = createFileRoute("/qr/$qrLookupID/help")({
  staticData: {
    pageName: "Help",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const support = useTheme().scannedArea?.theme.locationInformation.support

  if (support && (support.hasOnsiteHelp || support.email || support.phone)) {
    return <HelpRouteComponent {...support} />
  }

  // Use defaults if no help information all
  return (
    <HelpRouteComponent
      hasOnsiteHelp={false}
      phone={DEFAULT_HELP_PHONE}
      email={DEFAULT_HELP_EMAIL}
      onsiteHelperTitle=""
    />
  )
}
